/**
 * Camio API
 * @module api/config
 */

import Settings from '../settings';

const serverPath = Settings.serverPath;

/**
 * Gets the configuration from the camio server, including user config defaults.
 */
export const getConfig = () =>
  fetch(`${serverPath}Services/ConfigurationRestService.svc/GetConfig`, {
    method: 'get',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'include',
    dataType: 'json'
  })
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      throw new Error('Response not ok.');
    })
    .then(data => {
      if (data.statusCode === 500) {
        console.log(data);
        throw new Error('Unexpected error getting configuration from camio.  Bad JSON received.');
      }
      return Promise.resolve(JSON.parse(data));
    })
    .catch(error => {
      throw new Error(`getConfig failed: ${error}`);
    });

/**
 * Gets the user config from the camio server for the given user id,
 * or default config if no user is supplied
 * @param  {number} userId Id of the user
 */
export const getUserConfig = userId =>
  fetch(`${serverPath}Services/ConfigurationRestService.svc/GetUserConfig/${userId || ''}`, {
    method: 'get',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'include',
    dataType: 'json'
  })
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      throw new Error('Response not ok.');
    })
    .then(data => {
      if (data.statusCode === 500) {
        console.log(data);
        throw new Error(
          'Unexpected error getting user configuration from camio.  Bad JSON received.'
        );
      }
      return Promise.resolve(JSON.parse(data));
    })
    .catch(error => {
      throw new Error(`getUserConfig failed: ${error}`);
    });



// WEBPACK FOOTER //
// ./app/api/config.js